import { memo, useCallback } from 'react';

import { Button } from '@air/primitive-button';
import { useRetryAllUploads } from '@air/upload-utils';

export const WorkspaceUploadsRetryAllButton = memo(() => {
  const { retryAllUploads } = useRetryAllUploads();

  const handleRetryAll = useCallback(() => {
    retryAllUploads();
  }, [retryAllUploads]);

  return (
    <Button
      appearance="ghost"
      className="shrink-0 ads:text-primary text-gray-12"
      color="gray"
      data-testid="WORKSPACE_UPLOADS_RETRY_ALL_BUTTON"
      onClick={handleRetryAll}
      size="small"
      type="button"
    >
      Retry all
    </Button>
  );
});

WorkspaceUploadsRetryAllButton.displayName = 'WorkspaceUploadsRetryAllButton';
